import React from "react";

/**
 * HazardConnector — "Mirror Arrow": one integrated hazard-striped bar
 * shaped like a double-headed arrow with 180° rotational symmetry.
 * No squares, no tiny triangles — a single, precision industrial sign.
 */
export const HazardConnector = () => {
  return (
    <>
      {/* Desktop: horizontal mirror arrow */}
      <div
        className="hidden lg:flex relative items-center justify-center shrink-0"
        style={{ width: 240, height: 110 }}
        data-testid="hazard-connector"
      >
        <MirrorArrow />
      </div>

      {/* Mobile/tablet: vertical mirror arrow */}
      <div
        className="lg:hidden relative flex items-center justify-center shrink-0 my-2"
        style={{ width: 110, height: 200 }}
        data-testid="hazard-connector-mobile"
      >
        <MirrorArrow vertical />
      </div>
    </>
  );
};

/** A single integrated double-headed arrow filled with hazard stripes. */
const MirrorArrow = ({ vertical = false }) => {
  // Double-headed arrow polygon (rotational symmetric, 180°)
  const polygon =
    "polygon(0% 50%, 18% 0%, 18% 30%, 82% 30%, 82% 0%, 100% 50%, 82% 100%, 82% 70%, 18% 70%, 18% 100%)";

  const wrapStyle = vertical
    ? { transform: "rotate(90deg)", width: 200, height: 110 }
    : { width: "100%", height: "100%" };

  return (
    <div className="relative" style={wrapStyle}>
      {/* Black hairline silhouette (slightly larger) for crisp edge */}
      <div
        className="absolute inset-0 bg-black"
        style={{ clipPath: polygon, transform: "scale(1.035)" }}
        aria-hidden="true"
      />
      {/* The hazard-striped arrow body */}
      <div
        className="absolute inset-0 hazard-stripes-anim"
        style={{ clipPath: polygon }}
      />
      {/* Inner highlight stripe along the shaft for premium feel */}
      <div
        className="absolute left-[18%] right-[18%] top-[46%] h-[8%] bg-black/85 mix-blend-multiply"
        aria-hidden="true"
      />
    </div>
  );
};
